/// <amd-module name="SuiteCommerce.PagePrinter.ItemDetailsLayout.FieldsHelpersCatalog"/>
define("SuiteCommerce.PagePrinter.ItemDetailsLayout.FieldsHelpersCatalog", ["require", "exports", "SuiteCommerce.PagePrinter.ItemDetailsLayout.CheckCrossHelper", "SuiteCommerce.PagePrinter.ItemDetailsLayout.TextHelper", "SuiteCommerce.PagePrinter.ItemDetailsLayout.DateHelper", "SuiteCommerce.PagePrinter.ItemDetailsLayout.QRHelper"], function (require, exports, ItemDetailsLayout_CheckCrossHelper_1, ItemDetailsLayout_TextHelper_1, ItemDetailsLayout_DateHelper_1, ItemDetailsLayout_QRHelper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var HelpersCatalog = /** @class */ (function () {
        function HelpersCatalog() {
        }
        HelpersCatalog.initializeHelpers = function () {
            new ItemDetailsLayout_CheckCrossHelper_1.CheckCrossHelper();
            new ItemDetailsLayout_TextHelper_1.TextHelper();
            new ItemDetailsLayout_DateHelper_1.DateHelper();
            new ItemDetailsLayout_QRHelper_1.QRHelper();
        };
        return HelpersCatalog;
    }());
    exports.HelpersCatalog = HelpersCatalog;
});
